import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import GuestFaceFrontDeskList from './components/GuestFaceFrontDeskList'


const { Cell } = ResponsiveGrid;

const GuestFaceFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="人臉訪客前台"
        breadcrumbs={[
          {
            name: '人臉訪客',
          },
          {
            name: '人臉訪客前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <GuestFaceFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default GuestFaceFrontDesk;
